"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Basket = ({ basketElement, cart, isTransparent }) => {
    const { basketText: label, basketUrl: uri } = cart || {};
    return ((0, jsx_runtime_1.jsx)("div", { style: { position: 'relative' }, children: (0, react_1.isValidElement)(basketElement) && (0, react_1.cloneElement)(basketElement, { isTransparent, label, uri }) }));
};
exports.default = Basket;
